import { css } from '@emotion/css';
import Head from './Head';
import { useIsStoreAliasFirst } from 'hooks/business/store/useStoreName';

interface ClassicConversationHeadProps {
  conversation: Conversation.Conversation;
}

export function ClassicConversationHead(props: ClassicConversationHeadProps) {
  const { conversation } = props;
  const { channel, region, topBarInfo, buyerAvatar: avatar } = conversation;

  const isStoreAliasFirst = useIsStoreAliasFirst(channel, region);

  if (topBarInfo) {
    return (
      <Head
        className={head}
        info={topBarInfo}
        isStoreAliasFirst={isStoreAliasFirst}
        avatar={avatar}
        conversation={conversation}
      />
    );
  }

  return <div className={constraintContainer} />;
}

const constraintContainer = css`
  height: 48px;
  box-shadow: 0 0 1px 0px rgba(0, 0, 0, 0.2);
  margin-bottom: 1px;
`;

const head = css`
  min-height: 48px;
  height: 48px;
  flex: 0 0 40px;
  padding: 0 16px;
`;
